import * as yup from 'yup';
import {defaultString, emailString, country} from '../_types';

export default ({countries}) => {

  // const countries = JSON.parse(localStorage.getItem('countries'));

  return yup.object().shape({
    type: yup
      .string()
      .required()
      .oneOf(['rates', 'sum']),
    billAddress: yup.object().shape({
      houseNumber: yup.string().test(function(value) {
        const { street, postalCode, city, country } = this.parent;
        if (!!street || !!postalCode || !!city || !!country) {
          if (value == '' || value === undefined) {
            return false;
          }
        }

        return true;
      }),
      street: yup.string().test(function(value) {
        const { houseNumber, postalCode, city, country } = this.parent;
        if (!!houseNumber || !!postalCode || !!city || !!country) {
          if (value == '' || value === undefined) {
            return false;
          }
        }

        return true;
      }),
      postalCode: yup.string().test(function(value) {
        const { houseNumber, street, city, country } = this.parent;
        if (!!houseNumber || !!street || !!city || !!country) {
          if (value == '' || value === undefined) {
            return false;
          }
        }

        return true;
      }),
      city: yup.string().test(function(value) {
        const { houseNumber, street, postalCode, country } = this.parent;
        if (!!houseNumber || !!street || !!postalCode || !!country) {
          if (value == '' || value === undefined) {
            return false;
          }
        }

        return true;
      }),
      country: country(countries).test(function(value) {
        const { houseNumber, street, postalCode, city } = this.parent;
        if (!!houseNumber || !!street || !!postalCode || !!city) {
          if (value == '' || value === undefined) {
            return false;
          }
        }

        return true;
      }),
      company: defaultString(),
      email: emailString(),
      department: defaultString(),
    }),
  });

}
  